export const state = {
  selectedDefaultObject: null,
  selectedDetailsDevice: null,
  selectedDetailsDeviceStateHistory: null,
  selectedDetailsDeviceStateHistoryDetail: null,
  selectedDetailsDeviceStateHistoryDetailCondition: null,
  selectedDetailsAction: null,
  selectedDetailsInsight: null,
  selectedDetailsInteractCycle: null,
  selectedDetailsInteractActivity: null,
  selectedDetailsInteractActivityHistorical: null,
}

export const getters = {
  selectedDefaultObject(state) {
    return state.selectedDefaultObject
  },

  selectedDetailsDevice(state) {
    return state.selectedDetailsDevice
  },

  selectedDetailsDeviceStateHistory(state) {
    return state.selectedDetailsDeviceStateHistory
  },

  selectedDetailsDeviceStateHistoryDetail(state) {
    return state.selectedDetailsDeviceStateHistoryDetail
  },
  selectedDetailsDeviceStateHistoryDetailCondition(state) {
    return state.selectedDetailsDeviceStateHistoryDetailCondition
  },

  selectedDetailsAction(state) {
    return state.selectedDetailsAction
  },

  selectedDetailsInsight(state) {
    return state.selectedDetailsInsight
  },

  selectedDetailsInteractCycle(state) {
    return state.selectedDetailsInteractCycle
  },

  selectedDetailsInteractActivity(state) {
    return state.selectedDetailsInteractActivity
  },

  selectedDetailsInteractActivityHistorical(state) {
    return state.selectedDetailsInteractActivityHistorical
  },
}

export const mutations = {
  SET_SELECTED(state, detailsType) {
    if (detailsType === 'device') {
      state.selectedDetailsDevice = true
      state.selectedDetailsDeviceStateHistory = false
      state.selectedDetailsDeviceStateHistoryDetail = false
      state.selectedDetailsDeviceStateHistoryDetailCondition = false
      state.selectedDetailsAction = false
      state.selectedDetailsInsight = false
      state.selectedDetailsInteractCycle = false
      state.selectedDetailsInteractActivity = false
      state.selectedDetailsInteractActivityHistorical = false
    }
    if (detailsType === 'device-state-history') {
      state.selectedDetailsDeviceStateHistory = true
      state.selectedDetailsDevice = false
      state.selectedDetailsDeviceStateHistoryDetail = false
      state.selectedDetailsDeviceStateHistoryDetailCondition = false
      state.selectedDetailsAction = false
      state.selectedDetailsInsight = false
      state.selectedDetailsInteractCycle = false
      state.selectedDetailsInteractActivity = false
      state.selectedDetailsInteractActivityHistorical = false
    }
    if (detailsType === 'device-state-history-details') {
      state.selectedDetailsDeviceStateHistoryDetail = true
      state.selectedDetailsDeviceStateHistoryDetailCondition = false
      state.selectedDetailsDevice = false
      state.selectedDetailsDeviceStateHistory = false
      state.selectedDetailsAction = false
      state.selectedDetailsInsight = false
      state.selectedDetailsInteractCycle = false
      state.selectedDetailsInteractActivity = false
      state.selectedDetailsInteractActivityHistorical = false
    }
    if (detailsType === 'device-state-history-details-condition') {
      state.selectedDetailsDeviceStateHistoryDetailCondition = true
      state.selectedDetailsDeviceStateHistoryDetail = false
      state.selectedDetailsDevice = false
      state.selectedDetailsDeviceStateHistory = false
      state.selectedDetailsAction = false
      state.selectedDetailsInsight = false
      state.selectedDetailsInteractCycle = false
      state.selectedDetailsInteractActivity = false
      state.selectedDetailsInteractActivityHistorical = false
    }
    if (detailsType === 'action') {
      state.selectedDetailsAction = true
      state.selectedDetailsDevice = false
      state.selectedDetailsDeviceStateHistory = false
      state.selectedDetailsDeviceStateHistoryDetail = false
      state.selectedDetailsDeviceStateHistoryDetailCondition = false
      state.selectedDetailsInsight = false
      state.selectedDetailsInteractCycle = false
      state.selectedDetailsInteractActivity = false
      state.selectedDetailsInteractActivityHistorical = false
    }
    if (detailsType === 'insight') {
      state.selectedDetailsInsight = true
      state.selectedDetailsAction = false
      state.selectedDetailsDevice = false
      state.selectedDetailsDeviceStateHistory = false
      state.selectedDetailsDeviceStateHistoryDetail = false
      state.selectedDetailsDeviceStateHistoryDetailCondition = false
      state.selectedDetailsInteractCycle = false
      state.selectedDetailsInteractActivity = false
      state.selectedDetailsInteractActivityHistorical = false
    }
    if (detailsType === 'interact-cycle') {
      state.selectedDetailsInteractCycle = true
      state.selectedDetailsInsight = false
      state.selectedDetailsAction = false
      state.selectedDetailsDevice = false
      state.selectedDetailsDeviceStateHistory = false
      state.selectedDetailsDeviceStateHistoryDetail = false
      state.selectedDetailsDeviceStateHistoryDetailCondition = false
      state.selectedDetailsInteractActivity = false
      state.selectedDetailsInteractActivityHistorical = false
    }
    if (detailsType === 'interact-activity') {
      state.selectedDetailsInteractActivity = true
      state.selectedDetailsInsight = false
      state.selectedDetailsAction = false
      state.selectedDetailsDevice = false
      state.selectedDetailsDeviceStateHistory = false
      state.selectedDetailsDeviceStateHistoryDetail = false
      state.selectedDetailsDeviceStateHistoryDetailCondition = false
      state.selectedDetailsInteractCycle = false
      state.selectedDetailsInteractActivityHistorical = false
    }
    if (detailsType === 'interact-activity-historical') {
      state.selectedDetailsInteractActivityHistorical = true
      state.selectedDetailsInteractActivity = false
      state.selectedDetailsInsight = false
      state.selectedDetailsAction = false
      state.selectedDetailsDevice = false
      state.selectedDetailsDeviceStateHistory = false
      state.selectedDetailsDeviceStateHistoryDetail = false
      state.selectedDetailsDeviceStateHistoryDetailCondition = false
      state.selectedDetailsInteractCycle = false
    }
    if (detailsType === 'edge') {
      state.selectedDetailsAction = false
      state.selectedDetailsDevice = false
      state.selectedDetailsDeviceStateHistory = false
      state.selectedDetailsDeviceStateHistoryDetail = false
      state.selectedDetailsDeviceStateHistoryDetailCondition = false
      state.selectedDetailsInsight = false
      state.selectedDetailsInteractCycle = false
      state.selectedDetailsInteractActivity = false
      state.selectedDetailsInteractActivityHistorical = false
    }
  },

  SET_DEFAULT_OBJECT(state, defaultObject) {
    state.selectedDefaultObject = defaultObject
  },
}

export const actions = {
  selectDetailsDefault({ commit, state, rootState }, { detailsType, defaultObject }) {
    commit('SET_DEFAULT_OBJECT', defaultObject)
    commit('SET_SELECTED', detailsType)
  },
}
